import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastService } from '../shared/toast/toast.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
  ) {}

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | Observable<boolean>> {
    if (await this.authService.getUser()) {
      if (route.data && route.data.groups && !this.authService.isInGroups(route.data.groups)) {
        this.toastService.show("Vous n'avez pas l'autorisation d'accéder à cette page.", 'danger');
        this.router.navigate(['/']);
        return false;
      }
      // logged in so return true
      return true;
    }

    this.router.navigate(['/login']);
  }
}
